function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { jsonValidator } from "../common/JSONValidator/JSONValidator";
var _setPending = /*#__PURE__*/new WeakMap();
var _setRequestError = /*#__PURE__*/new WeakMap();
var _pendingRequestsCount = /*#__PURE__*/new WeakMap();
class Requester {
  constructor(setPending, setRequestError) {
    _classPrivateFieldInitSpec(this, _setPending, void 0);
    _classPrivateFieldInitSpec(this, _setRequestError, void 0);
    _classPrivateFieldInitSpec(this, _pendingRequestsCount, void 0);
    _classPrivateFieldSet(_setPending, this, setPending);
    _classPrivateFieldSet(_setRequestError, this, setRequestError);
    _classPrivateFieldSet(_pendingRequestsCount, this, 0);
  }

  /**
   * Block for story text generation. Keep doing clean code.
   * @module
   * @param {object} request
   * @param {string} request.method
   * @param {string} request.url
   * @param {object} [request.body]
   * @param {function} [onSuccess]
   * @param {function} [onError]
   * @param {object} [additionalHeaders]
   */
  request(request, onSuccess, onError, additionalHeaders) {
    var _this$pendingRequests, _this$pendingRequests2;
    _classPrivateFieldGet(_setPending, this).call(this, true);
    _classPrivateFieldGet(_setRequestError, this).call(this, null);
    _classPrivateFieldSet(_pendingRequestsCount, this, (_this$pendingRequests = _classPrivateFieldGet(_pendingRequestsCount, this), _this$pendingRequests2 = _this$pendingRequests++, _this$pendingRequests)), _this$pendingRequests2;
    const initialHeaders = {
      'Content-Type': 'application/json'
    };
    const headers = Object.assign(initialHeaders, additionalHeaders);
    const options = {
      method: request.method,
      body: request.body ? JSON.stringify(request.body) : null,
      headers: headers,
      credentials: 'include'
    };
    fetch(request.url, options).then(response => response.text().then(body => {
      const parsedBody = jsonValidator.validate(body) ? JSON.parse(body) : body;
      if (response.ok) {
        if (onSuccess) {
          onSuccess(parsedBody, response);
        }
        return;
      }
      const errorMessage = {
        response: {
          status: response.status,
          body: parsedBody
        }
      };
      throw new Error(JSON.stringify(errorMessage));
    })).catch(error => {
      const data = jsonValidator.validate(error.message) ? JSON.parse(error.message) : error.message;
      if (onError) {
        onError(data);
        return;
      }
      _classPrivateFieldGet(_setRequestError, this).call(this, data);
    }).finally(() => {
      var _this$pendingRequests3, _this$pendingRequests4;
      _classPrivateFieldSet(_pendingRequestsCount, this, (_this$pendingRequests3 = _classPrivateFieldGet(_pendingRequestsCount, this), _this$pendingRequests4 = _this$pendingRequests3--, _this$pendingRequests3)), _this$pendingRequests4;
      if (_classPrivateFieldGet(_pendingRequestsCount, this) === 0) {
        _classPrivateFieldGet(_setPending, this).call(this, false);
      }
    });
  }
  objectToQuery(object) {
    return new URLSearchParams(object).toString();
  }
}
const requester = new Requester();
export { Requester, requester };